module.exports = __webpack_public_path__ + "static/contact-bg-f4fb0b206baa47c8f18479c18cdeb3c2.jpg";